export default "__VITE_ASSET__c332aa6e__"